'use client';

import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import { Icon } from '@iconify/react';
import { mergeClasses } from 'minimal-shared/utils';
import { styled } from '@mui/material/styles';
import { icons } from './icon-sets';
import { iconifyClasses } from './classes';

// ----------------------------------------------------------------------

export function Iconify(t0) {
  const $ = _c(21);
  let className;
  let icon;
  let other;
  let sx;
  let t1;
  if ($[0] !== t0) {
    ({
      icon,
      className,
      width: t1,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = icon;
    $[3] = other;
    $[4] = sx;
    $[5] = t1;
  } else {
    className = $[1];
    icon = $[2];
    other = $[3];
    sx = $[4];
    t1 = $[5];
  }
  const width = t1 === undefined ? 20 : t1;
  const id = useId();
  const t2 = icons[icon] ?? icon;
  let t3;
  if ($[6] !== className) {
    t3 = mergeClasses([iconifyClasses.root, className]);
    $[6] = className;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== width) {
    t4 = {
      width,
      flexShrink: 0,
      height: width,
      display: "inline-flex"
    };
    $[8] = width;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== sx) {
    t5 = Array.isArray(sx) ? sx : [sx];
    $[10] = sx;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = [t4, ...t5];
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== id || $[16] !== other || $[17] !== t2 || $[18] !== t3 || $[19] !== t6) {
    t7 = <IconRoot ssr={true} id={id} icon={t2} className={t3} sx={t6} {...other} />;
    $[15] = id;
    $[16] = other;
    $[17] = t2;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
const IconRoot = styled(Icon)``;